import React from 'react';
import { Navbar } from 'react-bootstrap';

const Footer = () => (
  <Navbar className='footer'>
    <p>&copy; 2025 One Place Solar Pvt. Ltd. All rights reserved.</p>
  </Navbar >
);

export default Footer;